import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const STORAGE_KEY = 'ml:lang';

const translations = {
  de: {
    'lang.switch': 'EN',
    'lang.title': 'Sprache wechseln',
    'nav.login': 'Login',
    'nav.leagues': 'Ligen',
    'nav.subscriptions': 'Abos',
    'nav.tasks': 'Tasks',
    'nav.register': 'Registrieren',
    'nav.profile': 'Profil',
    'nav.teams': 'Teams',
    'nav.booking': 'Platz buchen',
    'nav.training': 'Training',
    'nav.clubs': 'Vereine',
    'nav.chats': 'Chats',
    'nav.news': 'Neuigkeiten',
    'nav.compliance': 'Compliance',
    'nav.logout': 'Abmelden',

    'nav.teamManager': 'Team Manager',
    'nav.competitionManager': 'Competition Manager',
    'nav.clubManager': 'Club Manager',
    'nav.locationManager': 'Location Manager',
    'nav.myMatches': 'Meine Matches',

    'myMatches.title': 'Meine Matches',
    'myMatches.loading': 'Lade Matches…',
    'myMatches.loadError': 'Fehler beim Laden der Matches',
    'myMatches.upcoming': 'Anstehend',
    'myMatches.completed': 'Abgeschlossen',
    'myMatches.noUpcoming': 'Keine anstehenden Matches.',
    'myMatches.noCompleted': 'Noch keine abgeschlossenen Matches.',
    'myMatches.findMatch': 'Match finden',
    'myMatches.statusPending': 'Ergebnis ausstehend',
    'myMatches.statusDisputed': 'Ergebnis angefochten',
    'myMatches.statusCompleted': 'Abgeschlossen',
    'myMatches.statusCancelled': 'Abgesagt',
    'myMatches.statusScheduled': 'Geplant',

    'subs.title': 'Abos',
    'subs.subtitle': 'MVP1: Nur FREE USER ist aktiv. Alle anderen Rollen kommen bald.',
    'subs.rolesTitle': 'Verfügbare Rollen',
    'subs.plansTitle': 'Lizenzpläne',
    'subs.footer': 'Für weitere Informationen oder individuelle Angebote kontaktiere uns bitte.',
    'subs.billing.free': 'Kostenlos',
    'subs.billing.comingSoon': 'Bald',
    'badge.active': 'Aktiv',
    'badge.internal': 'Intern',
    'badge.comingSoon': 'Coming Soon',

    'start.loading': 'Lade Startseite ...',
    'start.errorPrefix': 'Fehler',
    'start.welcome': 'Willkommen bei MatchLeague. Connect. Match. Win.',
    'start.sportPlaceholder': 'Sportart',
    'start.cityPlaceholder': 'Stadt',
    'start.searchMode': 'Suchmodus',
    'start.mode.match': 'Match',
    'start.mode.competition': 'Competition',
    'start.mode.competitionSoon': 'Competition (Coming Soon)',
    'start.mode.slot': 'Slot buchen',
    'start.mode.slotSoon': 'Slot buchen (Coming Soon)',
    'start.search': 'Suchen',
    'start.searching': 'Suche…',
    'start.upcoming': 'Kommende Spiele',
    'start.noUpcoming': 'Keine anstehenden Spiele.',
    'start.findMatch': 'Match suchen',
    'start.recent': 'Letzte Spiele',
    'start.noRecent': 'Keine vergangenen Spiele.',
    'start.details': 'Details',
    'start.toLeague': 'Zur Liga',
    'start.noStandings': 'Keine Tabellenstände verfügbar.',

    'start.activities.title': 'Aktivitäten',
    'start.activities.subtitle': 'Neueste Updates',
    'start.activities.filter.all': '📋 Alle',
    'start.activities.filter.matches': '⚽ Match-News',
    'start.activities.filter.friends': '👥 Freunde',
    'start.activities.empty.all': 'Keine Aktivitäten verfügbar.',
    'start.activities.empty.matches': 'Keine Match-News verfügbar.',
    'start.activities.empty.friends': 'Keine Freundes-Aktivitäten verfügbar.',
    'start.activities.adLabel': 'WERBUNG',
    'start.activities.showCourts': 'Verfügbare Plätze anzeigen',
    'start.loadError': 'Fehler beim Laden.',
    'start.myLeagues.title': 'Meine Ligen',
    'start.myLeagues.none': 'Du bist noch in keiner Liga angemeldet.',
    'start.myLeagues.searchLeague': 'Liga suchen',
    'start.myLeagues.leagueLabel': 'Liga:',

    'profile.title': 'Profil',
    'profile.errorOpen': 'Profil konnte nicht geöffnet werden. Bitte gehe zur Startseite und öffne dein Profil erneut.',
    'profile.toStart': 'Zur Startseite',

    'login.stats.loading': 'Lade Statistik…',
    'login.stats.users': 'Nutzer',
    'login.stats.confirmed': 'Bestätigt',
    'login.stats.leagues': 'Ligen',
    'login.stats.matches': 'Matches',
    'login.stats.teams': 'Teams',
    'login.stats.teamMembers': 'Team-Mitglieder',
    'login.stats.memberships': 'Liga-Mitgliedschaften',
    'login.stats.sports': 'Sportarten',

    'login.unconfirmed.title': 'E-Mail noch nicht bestätigt',
    'login.unconfirmed.subtitle': 'Bitte bestätige {email}',
    'login.unconfirmed.sending': 'Wird gesendet...',
    'login.unconfirmed.resend': 'E-Mail erneut senden',

    'login.reset.title': 'Passwort vergessen?',
    'login.reset.msg1': 'Möchtest du einen Link zum Zurücksetzen deines Passworts per E-Mail an',
    'login.reset.msg2': 'erhalten?',
    'login.reset.yourEmail': 'deine E-Mail-Adresse',
    'login.reset.cancel': 'Abbrechen',
    'login.reset.sending': 'Wird gesendet...',
    'login.reset.send': 'Ja, E-Mail senden',
    'login.reset.enterEmailFirst': 'Bitte gib zuerst deine E-Mail-Adresse im Login-Formular ein.',
    'login.reset.sentTitle': 'E-Mail versendet!',
    'login.reset.sentMsg1': 'Wir haben dir einen Link zum Zurücksetzen deines Passworts an',
    'login.reset.sentMsg2': 'gesendet. Bitte überprüfe dein Postfach.',
    'login.reset.close': 'Schließen',

    'login.resend.ok': '✅ Bestätigungs-E-Mail wurde erneut versendet!',
    'login.resend.wait': '⏱️ Bitte warte noch {minutes} Minuten, bevor du die E-Mail erneut anforderst.',
    'login.resend.error': 'Fehler beim Versenden der E-Mail.',
    'login.serverUnreachable': 'Server nicht erreichbar.',
    'login.password.placeholder': 'Passwort',
    'login.password.hide': 'Passwort verbergen',
    'login.password.show': 'Passwort anzeigen',
    'login.password.changedOk': '✅ Passwort erfolgreich geändert!',
    'login.password.resetError': 'Fehler beim Zurücksetzen.',
    'login.register': 'Registrieren',
    'login.tagline': 'Ein schneller Überblick über die Aktivität auf der Plattform – wächst jeden Tag.',
    'login.communityStatsTitle': 'Community Statistik',
    'login.updatedAt': 'Aktualisiert: {time}',

    'start.geo.notSupported': 'Dein Browser unterstützt keine Standortermittlung.',
    'start.geo.fetchCityError': 'Fehler beim Abrufen der nächsten Stadt. Bitte wähle deine Stadt manuell aus.',
    'start.geo.noCityFound': 'Keine Stadt in deiner Nähe gefunden. Bitte wähle deine Stadt manuell aus.',
    'start.geo.denied': 'Standortfreigabe wurde verweigert. Bitte erlaube den Zugriff in deinen Browser-Einstellungen.',
    'start.geo.unavailable': 'Standort konnte nicht ermittelt werden.',
    'start.geo.timeout': 'Zeitüberschreitung bei der Standortermittlung.',
    'start.geo.generic': 'Fehler bei der Standortermittlung. Bitte wähle deine Stadt manuell aus.',

    'footer.impressum': 'Impressum',
    'footer.privacy': 'Datenschutz',
    'footer.terms': 'Nutzungsbedingungen',
    'footer.report': 'Meldung rechtswidriger Inhalte',

    'report.title': 'Meldung rechtswidriger Inhalte',
    'report.subtitle': 'Meldeverfahren gemäß Digital Services Act (DSA)',
    'report.intro': 'MatchLeague stellt ein Meldeverfahren gemäß DSA bereit.',
    'report.reportable': 'Meldbar sind insbesondere:',
    'report.item1': 'rechtswidrige Inhalte',
    'report.item2': 'beleidigende oder diskriminierende Inhalte',
    'report.item3': 'unzulässige Profilbilder',
    'report.item4': 'Missbrauch der Plattform',
    'report.info': 'Meldungen werden direkt im Compliance-System erfasst und bearbeitet.',
    'report.requiredUserId': 'Pflicht: Bitte die sichtbare User-ID des gemeldeten Profils angeben.',
    'report.name': 'Dein Name (optional)',
    'report.email': 'Deine E-Mail (optional)',
    'report.reportedUserId': 'Gemeldete User-ID (aus Profil)',
    'report.subject': 'Betreff',
    'report.url': 'Link zum gemeldeten Inhalt (optional)',
    'report.message': 'Beschreibe den Vorfall so konkret wie möglich',
    'report.send': 'Meldung senden',
    'report.sending': 'Sende Meldung …',
    'report.success': 'Danke, deine Meldung wurde erfasst (ID #{id}).',
    'report.errSend': 'Meldung konnte nicht gesendet werden.',
    'report.cat.illegal': 'Rechtswidriger Inhalt',
    'report.cat.insultDefamation': 'Beleidigung / Rufmord',
    'report.cat.hate': 'Hassrede / Diskriminierung',
    'report.cat.harassment': 'Beleidigung / Diskriminierung',
    'report.cat.profile': 'Unzulässiges Profilbild',
    'report.cat.abuse': 'Plattform-Missbrauch',
    'report.cat.other': 'Sonstiges',

    'compliance.title': 'Compliance Dashboard',
    'compliance.subtitle': 'Offene Meldungen und Taskboard',
    'compliance.noAccess': 'Kein Zugriff. Diese Seite ist nur für Admins verfügbar.',
    'compliance.refresh': 'Aktualisieren',
    'compliance.open': 'Offen',
    'compliance.inReview': 'In Prüfung',
    'compliance.resolved': 'Erledigt',
    'compliance.rejected': 'Abgelehnt',
    'compliance.total': 'Gesamt',
    'compliance.openReports': 'Offene Meldungen',
    'compliance.loadingReports': 'Lade Meldungen …',
    'compliance.noReports': 'Keine offenen Meldungen.',
    'compliance.category': 'Kategorie',
    'compliance.reporter': 'Reporter',
    'compliance.unknown': 'unbekannt',
    'compliance.reportedUserId': 'Gemeldete User-ID',
    'compliance.url': 'URL',
    'compliance.setInReview': 'In Prüfung',
    'compliance.markResolved': 'Erledigt',
    'compliance.createTask': 'Task anlegen',
    'compliance.taskLinked': 'Task #{id} verknüpft',
    'compliance.taskboardOpen': 'Taskboard (offen)',
    'compliance.noOpenTasks': 'Keine offenen Tasks.',
    'compliance.assignee': 'Assignee',
    'compliance.errorLoad': 'Compliance-Daten konnten nicht geladen werden.',
    'compliance.errorUpdate': 'Meldung konnte nicht aktualisiert werden.',
    'compliance.errorTaskCreate': 'Task konnte nicht erstellt werden.',
    'compliance.errorTaskLink': 'Meldung konnte nicht mit Task verknüpft werden.',

    'match.cta.title': 'Mitspieler gesucht!',
    'match.cta.teamText': '{name} sucht Mitspieler für dieses Match. ({joined}{cap})',
    'match.cta.opponentText': '{name} sucht einen Gegner für dieses Match. Tritt bei und fordere ihn heraus!',
    'match.cta.joinNow': '✨ Jetzt beitreten',
    'match.cta.acceptChallenge': '⚔️ Challenge annehmen',
    'match.cta.weeklyLimit': 'Du hast diese Woche bereits ein Match in dieser Liga.',
    'match.join.loginRequired': 'Bitte einloggen.',
    'match.join.ok': 'Beigetreten.',
    'match.join.failed': 'Beitreten fehlgeschlagen.',
    'match.team.selectTitle': 'Team auswählen',
    'match.team.team1': 'Team 1',
    'match.team.team2': 'Team 2',
    'match.team.selected': 'Team gewählt.',
    'match.team.selectFailed': 'Teamwahl fehlgeschlagen.',
    'match.team.teamFull': 'Dieses Team ist bereits voll.',
    'match.team.notSelected': 'Du hast noch kein Team gewählt. Wähle dein Team, um loszulegen!',
    'match.loading': 'Lade Spiel ...',
    'match.errorPrefix': 'Fehler',
    'match.save.loading': '⏳ Speichere...',
    'match.saveResult': 'Ergebnis speichern',
    'match.save.error': 'Fehler beim Speichern.',
    'match.slots.loadError': 'Fehler beim Laden der Slots',
    'match.schedule.pickDateTime': 'Bitte Datum und Uhrzeit wählen.',
    'match.schedule.proposalTaken': 'Vorschlag übernommen. Bitte speichern.',
    'match.schedule.saving': '⏳ Speichere Termin...',
    'match.schedule.saved': '✅ Termin gespeichert!',
    'match.schedule.failed': 'Termin setzen fehlgeschlagen.',
    'match.suggest.failed': 'Vorschlag fehlgeschlagen.',
    'match.cancel.failed': 'Absagen fehlgeschlagen.',
    'match.cancel.confirm': 'Möchtest du dieses Match wirklich absagen?',
    'match.cancel.success': 'Match wurde abgesagt.',
    'match.proposal.accepted': '✅ Termin angenommen! Match-Startdatum wurde gesetzt.',
    'match.proposal.rejected': 'Terminvorschlag abgelehnt',
    'match.result.saved': '✅ Ergebnis gespeichert!',
    'match.result.pendingTitle': 'Ergebnis wartet auf Bestätigung',
    'match.result.opponentSubmitted': 'Dein Gegner hat dieses Ergebnis eingetragen. Stimmt das?',
    'match.result.waitingForOpponent': 'Warte auf Bestätigung durch deinen Gegner...',
    'match.result.confirm': 'Bestätigen',
    'match.result.reject': 'Ablehnen',
    'match.timeoutRetry': '⚠️ Zeitüberschreitung - Versuche es nochmal.',
    'match.notFound': 'Kein Spiel gefunden.',
    'match.cannot.kickoffNotSet': '📅 Termin noch nicht festgelegt',
    'match.cannot.kickoffNotReached': '⏰ Ergebnis kann erst ab Startdatum eingetragen werden',
    'match.cannot.leagueMembersOnly': '🔒 Nur Liga-Mitglieder',
    'match.proposal.acceptError': 'Fehler beim Annehmen',
    'match.proposal.rejectError': 'Fehler beim Ablehnen',
    'match.timeLocation.save': '💾 Termin & Ort speichern',
    'match.termin.change': 'Termin ändern',
    'match.termin.arrange': 'Termin vereinbaren',
    'match.termin.invitationSent': 'Einladung gesendet',
    'match.termin.proposalReceived': 'Termin vorschlag erhalten',
    'match.teamAvailability.title': 'Verfügbarkeiten eintragen',
    'match.teamAvailability.hint': 'Nach dem Beitritt bitte direkt deine freien Zeiten im Termin-Manager eintragen. Der Match-Ersteller legt den finalen Termin anhand der gemeinsamen Überschneidungen fest.',
    'match.teamAvailability.open': 'Termin-Manager öffnen',
    'match.teamAvailability.prompt': 'Team beigetreten. Bitte jetzt direkt deine Verfügbarkeiten im Termin-Manager eintragen.',
    'match.result.entryTitle': 'Ergebnis eintragen',
    'match.tennis.setCount': 'Anzahl Sätze:',
    'match.result.requiresTime': '📅 Ergebnis erst möglich, wenn ein Termin festgelegt ist.',
    'match.booking.locationLabel': 'Ort / Adresse',
    'match.booking.locationPlaceholder': 'Standort wählen',
    'match.booking.date': '📅 Datum',
    'match.booking.time': '🕐 Uhrzeit',
    'match.booking.city': '📍 Stadt',
    'match.booking.cityDefault': 'Standard: {city}',
    'match.booking.allCities': 'Alle Städte',
    'match.booking.availableCourts': 'Verfügbare Plätze',
    'match.booking.courtsCount': '{count} Plätze',
    'match.booking.searchingCourts': 'Suche verfügbare Plätze...',
    'match.booking.noCourtsFound': 'Keine verfügbaren Plätze gefunden',
    'match.booking.forTime': 'für {date} um {time} Uhr',
    'match.booking.tryOther': 'Versuche ein anderes Datum oder eine andere Uhrzeit.',
    'match.booking.nextFree': 'NÄCHSTER FREIER PLATZ',

    'tm.title': 'Termin Manager',
    'tm.loading': 'Laden...',
    'tm.availableTimes': 'Verfügbare Zeiten',
    'tm.addSlot': 'Slot hinzufügen',
    'tm.closeSlot': 'Schließen',
    'tm.noTimes': 'Noch keine Zeiten hinterlegt.',
    'tm.date': 'Datum',
    'tm.from': 'Von',
    'tm.to': 'Bis',
    'tm.save': 'Speichern',
    'tm.cancel': 'Abbrechen',
    'tm.fillDateAndTime': 'Bitte Datum und Zeit ausfüllen',
    'tm.endAfterStart': 'Endzeit muss nach Startzeit liegen',
    'tm.saveError': 'Fehler beim Speichern',
    'tm.latestStart': 'Spätester Start: {time}',
    'tm.duration': 'Dauer {min} Min',
    'tm.sendInvitation': 'Einladung senden',
    'tm.onlyGuestCanSend': 'Nur der Gast kann eine Anfrage senden.',
    'tm.invalidTime': 'Ungültige Zeitangabe.',
    'tm.outsideFrame': 'Startzeit liegt außerhalb des Host-Slots.',
    'tm.sendError': 'Fehler beim Senden',
    'tm.yourAvailability': 'Deine Verfügbarkeiten',
    'tm.yourSlot': 'Dein Slot',
    'tm.opponentAvailability': 'Verfügbarkeiten des Gegners',
    'tm.proposals': 'Terminvorschläge',
    'tm.noRequests': 'Keine Anfragen vorhanden.',
    'tm.proposal': 'Terminvorschlag',
    'tm.byYou': 'von dir',
    'tm.byOpponent': 'vom Gegner',
    'tm.byHost': 'vom Host',
    'tm.status': 'Status',
    'tm.pending': 'ausstehend',
    'tm.accept': 'Annehmen',
    'tm.counterProposal': 'Gegenvorschlag',
    'tm.reject': 'Ablehnen',
    'tm.withdraw': 'Zurückziehen',
    'tm.acceptSlot': 'Akzeptieren',
    'tm.sendCounter': 'Gegenvorschlag senden',
    'tm.proposeTime': 'Termin vorschlagen',
    'tm.availableRange': 'Verfügbarer Zeitraum: {from} - {to}',
    'tm.playTime': 'Spielzeit: {min} Min',
    'tm.desiredStart': 'Gewünschte Startzeit',
    'tm.ofAvailable': '{current} von {total} verfügbaren Zeiten',
    'tm.sending': 'Wird gesendet...',
    'tm.sendInvitationFull': 'Einladung versenden',
    'tm.counterSent': 'Gegenvorschlag erfolgreich versendet!',
    'tm.invitationSent': 'Einladung erfolgreich versendet!',
    'tm.proposalRejected': 'Terminvorschlag abgelehnt',
    'tm.selectStartTime': 'Bitte eine Startzeit wählen',
    'tm.outsideAvail': 'Startzeit liegt außerhalb des Verfügbarkeits-Slots.',
    'tm.acceptError': 'Fehler beim Akzeptieren',
    'tm.deleteError': 'Fehler beim Löschen',
    'tm.rejectError': 'Fehler beim Ablehnen',
    'tm.player1': 'Spieler 1',
    'tm.player2': 'Spieler 2',
    'tm.slotCount': '{count} Slot(s)',
    'tm.myTimes': 'Meine Verfügbarkeit',
    'tm.myTimesHint': 'Hier siehst du deine eingetragenen Zeitfenster.',
    'tm.noMyTimes': 'Du hast noch keine Zeiten hinterlegt. Trage Zeitfenster ein, in denen du spielen kannst.',
    'tm.opponentTimes': 'Gegner-Verfügbarkeit',
    'tm.opponentTimesHint': 'Hier sind die Zeiten deines Gegners. Wähle eine aus und sende eine Spielanfrage.',
    'tm.delete': 'Löschen',
    'tm.deleteFrameConfirm': 'Dieses Zeitfenster wirklich löschen?',
    'tm.frameSaved': 'Zeitfenster gespeichert!',
    'tm.frameDeleted': 'Zeitfenster gelöscht.',
    'tm.slotProposed': 'Spielanfrage gesendet!',
    'tm.slotAccepted': 'Termin bestätigt!',

    'common.cancel': 'Abbrechen',
    'common.openProfile': 'Profil öffnen',

    'register.minAge': 'Du musst mindestens 16 Jahre alt sein, um dich zu registrieren.',
    'register.confirmAgeTerms': 'Bitte bestätige, dass du mindestens 16 Jahre alt bist und die Nutzungsbedingungen sowie Datenschutzerklärung akzeptierst.',
    'register.success': 'Registrierung erfolgreich! Bitte prüfe dein E-Mail-Postfach und bestätige den Link.',
    'register.failed': 'Registrierung fehlgeschlagen. Bitte überprüfe deine Daten.',
    'register.button': 'Registrieren',
    'register.sending': 'Wird gesendet...',
    'register.title': 'Registrieren',
    'register.subtitle': 'Erstelle deinen Account und werde Teil der Community',
    'register.firstName': 'Vorname',
    'register.lastName': 'Nachname',
    'register.email': 'E-Mail',
    'register.password': 'Passwort',
    'register.passwordConfirm': 'Passwort bestätigen',
    'register.passwordRepeat': 'Passwort wiederholen',
    'register.passwordMismatch': 'Passwörter stimmen nicht überein',
    'register.passwordMatch': '✓ Passwörter stimmen überein',
    'register.cityDistrictPlaceholder': 'Stadt oder Bezirk wählen',
    'register.locationOptional': 'Standort (optional)',
    'register.birthday': 'Geburtstag',
    'register.gender': 'Geschlecht',
    'register.genderPlaceholder': '-- Geschlecht wählen --',
    'register.gender.male': 'Männlich',
    'register.gender.female': 'Weiblich',
    'register.gender.other': 'Divers',
    'register.terms': 'Ich bestätige, dass ich mindestens 16 Jahre alt bin, und akzeptiere die',
    'register.terms.termsLink': 'Nutzungsbedingungen',
    'register.terms.privacyLink': 'Datenschutzerklärung (DSGVO)',
    'register.alreadyRegistered': 'Bereits registriert?',
    'register.toLogin': 'Zum Login',

    'subs.features.teamCaptain': 'Team gründen / Mitglieder / Liga-Anmeldung',
    'subs.features.clubOwner': 'Mehrere Teams verwalten / Trainer zuweisen / Club-Dashboard',
    'subs.features.locationOwner': 'Location erstellen / Plätze definieren / Slots generieren',
    'subs.features.eventOwner': 'Liga erstellen / Tabellen / Turniere konfigurieren',
    'subs.features.trainer': 'Trainings planen / Teilnehmer verwalten / Leistungsdaten tracken',

    'editProfile.loadError': 'Fehler beim Laden des Profils',
    'editProfile.saveOk': 'Profil erfolgreich gespeichert',
    'editProfile.saveErrorPrefix': 'Fehler beim Speichern: {error}',
    'editProfile.loading': 'Lädt...',
    'editProfile.saveChanges': 'Änderungen speichern',
    'editProfile.saving': 'Speichert...',
    'editProfile.selectPlaceholder': 'Bitte wählen',
    'editProfile.title': 'Persönliche Daten bearbeiten',
    'editProfile.gender': 'Geschlecht',
    'editProfile.back': 'Zurück',
    'editProfile.gender.male': 'Männlich',
    'editProfile.gender.female': 'Weiblich',
    'editProfile.gender.diverse': 'Divers',
    'editProfile.gender.na': 'Keine Angabe',
    'editProfile.bio': 'Bio / Über mich',
    'editProfile.bioPlaceholder': 'Erzähle etwas über dich...',
    'editProfile.locationPlaceholder': 'Standort wählen',

    'match.creator.title': 'Mitspieler gesucht',
    'match.creator.subtitle': 'Dein Match ist veröffentlicht und für alle Spieler sichtbar.',
    'match.creator.badgeActive': '🎯 Spiel aktiv',

    'league.join.ok': '✅ Beigetreten.',
    'league.join.alreadyMember': 'Bereits Mitglied',
    'league.join.paired': 'Ein Match wurde dir direkt zugewiesen.',
    'league.join.created': 'Ein offenes Match wurde für dich erstellt.',
    'league.join.existing': 'Du hattest bereits ein offenes Match.',
    'league.join.error': 'Match-Zuordnung fehlgeschlagen: {error}.',
    'league.join.auto.joined': 'Automatische Matchsuche: Du wurdest einem offenen Match hinzugefügt.',
    'league.join.auto.created': 'Automatische Matchsuche: Offenes Match erstellt.',
    'league.join.auto.paired': 'Automatische Matchsuche: Gegner gefunden.',
    'league.join.auto.skipped': 'Automatische Matchsuche: Bereits ein offenes Match vorhanden.',

    'league.loading': 'Lade Liga ...',
    'league.noData': 'Keine Daten.',
    'league.pickOpponent': 'Bitte einen Gegner wählen.',
    'league.pickDateTime': 'Bitte Datum/Zeit wählen.',
    'league.createMatchFailed': 'Match erstellen fehlgeschlagen: {error}',
    'league.searchMatch': 'Match suchen',
    'league.searching': 'Suchen...',
    'league.search.result.joined': 'Match gefunden und beigetreten',
    'league.search.result.created': 'Offenes Match erstellt',
    'league.search.result.paired': 'Gegner ohne Wochen-Spiel gefunden. Vorschlag erstellt.',
    'league.search.result.skipped': 'Du hast bereits ein offenes Match.',
    'league.search.failed': 'Match-Suche fehlgeschlagen: {error}',
    'league.openMatch.notice': 'Du hast bereits ein offenes Match.',
    'league.openMatch.toMatch': 'Zum Match',
    'league.weeklyLimit': 'Du hattest diese Woche bereits ein Spiel. Die Matchsuche ist nächste Woche wieder verfügbar.',
    'league.loadingExtra': 'Lade zusätzliche Daten...',
    'league.table.title': 'Tabelle',
    'league.table.season': 'Saison:',
    'league.table.currentSeason': 'Aktuelle Saison',
    'league.table.noEntries': 'Keine Einträge.',
    'league.table.place': 'Platz',
    'league.table.teamPlayer': 'Team/Spieler',
    'league.table.played': 'Sp',
    'league.table.won': 'S',
    'league.table.draw': 'U',
    'league.table.lost': 'N',
    'league.table.goals': 'Tore',
    'league.table.diff': 'Diff',
    'league.table.points': 'Pkt',
    'league.table.form': 'Form',
    'league.backToOverview': '← Zurück zur Übersicht',
    'league.openProfile': 'Profil öffnen',
    'league.noUpcoming': 'Keine kommenden Spiele.',
    'league.noCompleted': 'Keine abgeschlossenen Spiele.',
    'league.noDataYet': 'Noch keine Daten',
    'league.leader': 'Tabellenführer',
    'league.points': 'Punkte',
    'league.games': 'Spiele',
    'league.goals': 'Tore',

    'leagues.info': 'ℹ️ Info',
    'leagues.join': 'Beitreten',
    'leagues.loadingMore': 'Lädt...',
    'leagues.loadMore': 'Mehr laden ({current} von {total})',
    'leagues.loading': 'Lade Ligen …',
    'leagues.title': 'Ligen',
    'leagues.subtitle': 'Finde die perfekte Liga für deinen Sport in deiner Region',
    'leagues.filterTitle': 'Filter & Suche',
    'leagues.searchLabel': 'Suche',
    'leagues.searchPlaceholder': 'Liga, Stadt oder Sport suchen...',
    'leagues.sportPlaceholder': 'Sportart wählen...',
    'leagues.cityPlaceholder': 'Stadt wählen...',
    'leagues.resetFilters': 'Alle Filter zurücksetzen',
    'leagues.foundCount': '{count} Ligen gefunden',
    'leagues.noneTitle': 'Keine Ligen gefunden',
    'leagues.noneHint': 'Versuche andere Filter oder erweitere deine Suche',
    'leagues.moreAvailable': '{count} weitere Ligen verfügbar',
    'leagues.detailUnavailable': 'Detail nicht verfügbar',
    'leagues.showing': 'Zeige {shown} von {total} Ligen',

    'match.createPublic.title': 'Öffentliches Match erstellen',
    'match.createPublic.subtitle': 'Erstelle ein öffentliches Match, das andere Spieler finden und beitreten können.',
    'match.createPublic.subtitleLong': 'Erstelle ein öffentliches Match, das andere Spieler finden und beitreten können. Wähle Sportart, Stadt und einen verfügbaren Platz.',

    // GameDetailPage – time helpers
    'match.time.inDays': 'in {count} Tagen',
    'match.time.agoDays': 'vor {count} Tagen',
    'match.time.inHours': 'in {count} Stunden',
    'match.time.agoHours': 'vor {count} Stunden',
    'match.time.inMinutes': 'in {count} Minuten',
    'match.time.agoMinutes': 'vor {count} Minuten',
    'match.time.expired': 'abgelaufen',
    'match.time.remainDays': 'noch {count} Tage',
    'match.time.remain1Day': 'noch 1 Tag',
    'match.time.remainHours': 'noch {count} Stunden',
    'match.time.remainMinutes': 'noch {count} Minuten',

    // GameDetailPage – status labels
    'match.status.completed': 'Absolviert',
    'match.status.scheduled': 'Match geplant',
    'match.status.pending': 'Match ausstehend',
    'match.status.datePending': 'Termin ausstehend',
    'match.status.completedNoResult': 'Absolviert / ohne Ergebnis',
    'match.status.live': 'Live',
    'match.status.ongoing': 'Laufend',
    'match.status.today': 'Heute',
    'match.status.cancelled': 'Abgesagt',
    'match.status.resultPending': 'Ergebnis ausstehend',
    'match.status.resultDisputed': 'Ergebnis abgelehnt',

    // GameDetailPage – proposal / termin section
    'match.proposal.title': '📅 Terminvorschlag',
    'match.proposal.fallback': 'Terminvorschlag',
    'match.proposal.byYou': 'von dir',
    'match.proposal.byOpponent': 'vom Gegner',
    'match.proposal.statusPending': 'ausstehend',
    'match.proposal.accept': 'Annehmen',
    'match.proposal.counter': 'Gegenvorschlag',
    'match.proposal.reject': 'Ablehnen',

    // GameDetailPage – date display
    'match.date.rangeNext': '📅 In den nächsten {count} Tagen',
    'match.date.rangeNext1': '📅 In den nächsten 1 Tag',
    'match.date.period': '📅 Zeitraum: {from} - {to}',
    'match.date.until': '📅 Bis {date}',
    'match.date.noneYet': '⏰ Noch kein Termin vereinbart',
    'match.date.periodLabel': 'Zeitraum: {from} - {to}',
    'match.date.periodFlex': 'Zeitraum flexibel',
    'match.date.fixedDate': '📅 Festes Datum',
    'match.date.dateOpen': '🕐 Datum offen',
    'match.date.untilPlain': 'Bis {date}',

    // GameDetailPage – chat & action buttons
    'match.chat': 'Match-Chat',
    'match.deadline.hint': '{remaining} um den Termin zu vereinbaren',
    'match.scheduled.countdown': 'noch {remaining} bis zum Termin',
    'match.cancel': 'ABSAGEN',

    // GameDetailPage – last form
    'match.lastForm': 'Letzte 5',
    'match.form.win': 'S',
    'match.form.draw': 'U',
    'match.form.loss': 'N',

    // GameDetailPage – network error
    'match.networkError': 'Netzwerkfehler',

    // ScheduleSection 
    'match.schedule.editDate': 'Termin bearbeiten',
    'match.schedule.setLocation': '1️⃣ Location festlegen',
    'match.schedule.bookCourt': '🏟️ Platz buchen',
    'match.schedule.bookNow': 'Jetzt buchen →',
    'match.schedule.manualLocation': '📍 Ort manuell eingeben',
    'match.schedule.timeDisplay': '🕐 {start} - {end} Uhr',

    // Rank
    'match.rank': '{rank}. Rang',

    // Proposal labels in GameDetailPage
    'match.proposal.title': '📅 Terminvorschlag',
    'match.proposal.byYou': 'von dir',
    'match.proposal.byOpponent': 'vom Gegner',
    'match.proposal.pending': 'ausstehend',
    'match.proposal.accept': 'Annehmen',
    'match.proposal.counter': 'Gegenvorschlag',
    'match.proposal.reject': 'Ablehnen',
    'match.proposal.details': 'Details ansehen',
    'match.proposal.label': 'Terminvorschlag',

    // League fallback
    'match.leagueFallback': 'Liga',
    'match.notLoggedIn': 'Nicht eingeloggt',

    // SearchMatchDialog
    'match.search.presetMorning': '🌅 Morgens',
    'match.search.presetMidday': '☀️ Mittags',
    'match.search.presetEvening': '🌙 Abends',
    'match.search.errorCompleteStep3': 'Bitte Schritt 3 abschließen, bevor Verfügbarkeiten gesetzt werden.',
    'match.search.errorSelectDate': 'Bitte Datum wählen.',
    'match.search.errorValidTimeRange': 'Bitte gültige Zeitspanne wählen (von < bis).',
    'match.search.errorSlotConflict': 'Konflikt: Überschneidung mit bestehendem Slot.',
    'match.search.errorValidTimeRanges': 'Bitte gültige Zeitspannen wählen (von < bis).',
    'match.search.errorOverlappingSlots': 'Konflikt: Überlappende Slots am selben Tag.',
    'match.search.errorSelectTimePeriod': 'Bitte mindestens einen Zeitraum auswählen.',
    'match.search.errorNoTimePeriodAdded': 'Kein Zeitraum hinzugefügt (evtl. Konflikte).',
    'match.search.errorLoginFirst': 'Bitte zuerst anmelden.',
    'match.search.errorSelectSportCity': 'Bitte Sportart und Stadt auswählen.',
    'match.search.errorSelectLevel': 'Bitte wähle ein Level aus',
    'match.search.errorSelectAtLeastOneDate': 'Bitte mindestens ein Datum wählen.',
    'match.search.errorEnterAvailability': 'Bitte mindestens einen verfügbaren Zeitraum eintragen',
    'match.search.errorCreateFailed': 'Konnte Match nicht erstellen',
    'match.search.errorCreatingMatch': 'Fehler beim Erstellen',
    'match.search.title': 'Match suchen',
    'match.search.createMatch': 'Match erstellen',
    'match.search.loginToCreate': 'Einloggen um zu erstellen',
    'match.search.openOwnMatch': 'Eigenes Match eröffnen',
    'match.search.selectSport': 'Sportart wählen',
    'match.search.city': 'Stadt',
    'match.search.next3Days': 'In den nächsten 3 Tagen',
    'match.search.next7Days': 'In den nächsten 7 Tagen',
    'match.search.next14Days': 'In den nächsten 14 Tagen',
    'match.search.next30Days': 'In den nächsten 30 Tagen',
    'match.search.selectPeriod': 'Zeitraum wählen',
    'match.search.selectDays': 'Tage wählen',
    'match.search.tableView': 'Tabellenansicht',
    'match.search.cardView': 'Kartenansicht',
    'match.search.mapView': 'Kartenansicht',
    'match.search.thSport': 'Sport',
    'match.search.thPlayer': 'Spieler',
    'match.search.thLocation': 'Ort',
    'match.search.thTime': 'Zeit',
    'match.search.thAction': 'Aktion',
    'match.search.opponentWanted': 'Gegner gesucht',
    'match.search.statusPending': 'Ausstehend',
    'match.search.dateOpen': 'Datum: offen',
    'match.search.inDays': 'In {days} Tag(en)',
    'match.search.periodOpen': 'Zeitraum: offen',
    'match.search.levelOpen': 'Offen',
    'match.search.statusOpen': '🟢 Offen',
    'match.search.statusScheduled': '📅 Geplant',
    'match.search.inNextDays': 'In den nächsten {days} Tag(en)',
    'match.search.dateFixedRange': 'am {dayName} {date}, zwischen {start}-{end} Uhr',
    'match.search.dateExact': 'am {dayName} {date}, um {time} Uhr',
    'match.search.noResults': 'Keine offenen Matches gefunden.',
    'match.search.mapViewTitle': 'Kartenansicht',
    'match.search.mapViewDesc': 'Die Kartenansicht zeigt alle verfügbaren Matches auf einer interaktiven Karte mit ihren Standorten.',
    'match.search.mapViewWip': '🚧 In Entwicklung - Verfügbar in einer kommenden Version',
    'match.search.step1Label': 'Sport und Ort',
    'match.search.selectSportEmoji': '🏃 Sportart wählen',
    'match.search.selectCity': 'Stadt wählen',
    'match.search.bookVenueOptional': '🏟️ Platz buchen (optional)',
    'match.search.noVenueSelected': 'Kein Platz ausgewählt',
    'match.search.desiredTime': 'Gewünschter Zeitpunkt',
    'match.search.fixedDay': 'Fester Tag',
    'match.search.period': 'Zeitraum',
    'match.search.timeWindow': 'Zeitfenster',
    'match.search.date': 'Datum',
    'match.search.inTheNext': 'In den nächsten:',
    'match.search.threeDays': '3 Tage',
    'match.search.sevenDays': '7 Tage',
    'match.search.fourteenDays': '14 Tage',
    'match.search.fromStartDate': 'Von (Start-Datum)',
    'match.search.toEndDate': 'Bis (End-Datum)',
    'match.search.preferredTimeOptional': 'Bevorzugte Zeit (optional)',
    'match.search.specificTime': 'Konkrete Zeit',
    'match.search.timeOfDay': 'Tageszeit',
    'match.search.from': 'Von',
    'match.search.to': 'Bis',
    'match.search.gameDuration': 'Spiellänge',
    'match.search.gameDurationDesc': 'Spiellänge (gilt für das gesamte Match)',
    'match.search.decreaseDuration': 'Slotdauer verkürzen',
    'match.search.increaseDuration': 'Slotdauer verlängern',
    'match.search.appliesAllAvailabilities': 'Gilt für alle Verfügbarkeiten dieses Matches.',
    'match.search.enterAvailabilities': 'Verfügbarkeiten eintragen',
    'match.search.configuration': 'Konfiguration',
    'match.search.periodsForAllDays': 'Zeiträume für alle Tage',
    'match.search.availabilityPerDay': 'Verfügbarkeit pro Tag',
    'match.search.presetHint': 'Wähle einen oder mehrere Zeiträume. Sie werden beim Absenden des Formulars auf alle markierten Tage angewendet.',
    'match.search.pleaseSelectPeriodAbove': 'Bitte oben einen Zeitraum wählen.',
    'match.search.removeRow': 'Zeile entfernen',
    'match.search.addNewRow': '+ Neue Zeile',
    'match.search.availableVenues': 'Verfügbare Plätze',
    'match.search.searchingVenues': 'Suche verfügbare Plätze...',
    'match.search.noVenuesAvailable': 'Keine freien Plätze für diese Auswahl verfügbar',
    'match.search.priceOnRequest': 'Preis auf Anfrage',
    'match.search.freeSlot': 'freier Platz',
    'match.search.freeSlots': 'freie Plätze',
    'match.search.bookVenueAt': 'Platz bei {name} buchen',
    'match.search.bookVenue': 'Platz buchen',
    'match.search.cancel': 'Abbrechen',
    'match.search.creatingMatch': 'Erstelle Match...',

    // EditProfilePage
    'editProfile.firstname': 'Vorname *',
    'editProfile.firstnamePlaceholder': 'Dein Vorname',
    'editProfile.lastname': 'Nachname *',
    'editProfile.lastnamePlaceholder': 'Dein Nachname',
    'editProfile.username': 'Benutzername',
    'editProfile.usernamePlaceholder': 'Dein Benutzername',
    'editProfile.emailPlaceholder': 'deine@email.de',
    'editProfile.location': 'Standort',
    'editProfile.phone': 'Telefonnummer',
    'editProfile.birthday': 'Geburtsdatum',

    // LoginPage
    'login.failed': 'Login fehlgeschlagen.',
    'login.success': '✅ Login erfolgreich!',
    'login.testFailed': 'Testuser-Login fehlgeschlagen.',
    'login.testSuccess': '✅ Testuser-Login erfolgreich!',
    'login.resendError': 'Fehler beim Versenden der E-Mail.',
    'login.welcomeTitle': 'Willkommen bei Match League',
    'login.tagline': 'verbindet Sportler, Teams und Locations – vom spontanen Match bis zur Liga.',

    // LeaguesPage extras
    'leagues.city': 'Stadt',
    'leagues.onlyMine': 'Nur meine Ligen anzeigen',
    'leagues.league': 'Liga',
    'leagues.members': 'Mitglieder',
    'leagues.fallbackName': 'Liga {id}',

    // LeagueDetailPage extras
    'league.error': 'Fehler',
    'league.joinFailed': 'Beitritt fehlgeschlagen: {error}',
    'league.left': 'Ausgetreten',
    'league.notMember': 'Nicht Mitglied',
    'league.leaveFailed': 'Austritt fehlgeschlagen: {error}',
    'league.noDate': 'Noch kein Termin',
    'league.members': 'Mitglieder',
    'league.weeklyLimit': 'Du kannst nur ein offenes Match gleichzeitig haben und nur ein Match pro Woche spielen.',

    // StartPage extras
    'start.result': 'Ergebnis: {home}:{away}',
    'start.leagueLabel': 'Liga',
    'start.leagueMember': 'Liga-Mitglied',
    'start.dateTbd': 'Termin tbd',
    'start.rank': 'Platz',
    'start.teamPlayer': 'Team/Spieler',
    'start.bookNow': 'Jetzt Platz buchen bei {name}!',

    // SubscriptionsPage (role descriptions)
    'subs.desc.free': 'Basisrolle – kostenlos. Matches erstellen, suchen, beitreten und chatten.',
    'subs.desc.teamCaptain': 'Team-Organisation (Team gründen, Mitglieder, Liga-Anmeldung).',
    'subs.desc.clubOwner': 'Vereinsstruktur & mehrere Teams verwalten.',
    'subs.desc.locationOwner': 'Sportanlagen & Plätze verwalten (Booking später).',
    'subs.desc.eventOwner': 'Ligen & Turniere organisieren.',
    'subs.desc.trainer': 'Trainings planen, Gruppen verwalten, Leistung tracken.',
    'subs.role.eventOwner': 'EVENT OWNER / LIGA MANAGER',
    'subs.comingSoon.eventOwner': 'Kommt bald – Ligen/Turniere organisieren.',
    'subs.feature.editProfile': 'profil bearbeiten',
    'subs.feature.chooseSportCity': 'sport & stadt wählen',
    'subs.feature.createMatch': 'match erstellen',
    'subs.feature.searchMatch': 'match suchen',
    'subs.feature.useChat': 'match-chat nutzen',
    'subs.feature.createTeam': 'team gründen',
    'subs.feature.inviteMembers': 'mitglieder einladen',
    'subs.feature.registerTeam': 'team in liga anmelden',
    'subs.feature.manageTeams': 'mehrere teams verwalten',
    'subs.feature.assignTrainer': 'trainer zuweisen',
    'subs.feature.clubDashboard': 'club-dashboard',
    'subs.feature.createLocation': 'location erstellen',
    'subs.feature.defineCourts': 'plätze definieren',
    'subs.feature.generateSlots': 'slots generieren',
    'subs.feature.createLeague': 'liga erstellen',
    'subs.feature.tables': 'tabellen',
    'subs.feature.configTournaments': 'turniere konfigurieren',
    'subs.feature.planTraining': 'trainings planen',
    'subs.feature.manageParticipants': 'teilnehmer verwalten',
    'subs.feature.trackPerformance': 'leistungsdaten tracken',
    'subs.duration': 'Laufzeit: {days} Tage',

    // WelcomePage
    'welcome.title': 'Willkommen bei Match League',
    'welcome.subtitle': 'Match League verbindet Sportler, Teams und Locations – vom spontanen Match bis zur Liga.',
    'welcome.description': 'Finde passende Matches, tritt Ligen bei und bleib mit deiner Sport-Community verbunden.',
    'welcome.accountActive': '✓ Dein Konto ist jetzt aktiv',
    'welcome.canStart': 'Du kannst direkt loslegen und dein nächstes Spiel starten.',
    'welcome.confirmError': 'Fehler bei der Bestätigung',
    'welcome.almostDone': 'Fast fertig',
    'welcome.invalidLink': 'Der Bestätigungslink ist ungültig oder abgelaufen. Bitte fordere eine neue Bestätigungs-Mail an oder kontaktiere den Support.',
    'welcome.pleaseConfirm': 'Bitte bestätige deine E-Mail-Adresse. Prüfe ggf. den Spam-Ordner.',

    // ChatsPage
    'chats.loginRequired': 'Bitte einloggen, um Chats zu sehen.',
    'chats.loadError': 'Chats konnten nicht geladen werden.',
    'chats.loading': 'Lade Chats ...',
    'chats.empty': 'Du hast aktuell keine Chats. Starte ein Match, um loszulegen!',
    'chats.private': 'Privater Chat',
    'chats.matchChat': 'Match-Chat',
    'chats.leagueUnknown': 'Liga unbekannt',
    'chats.lastMessage': 'Letzte Nachricht',
    'chats.noMessages': 'Noch keine Nachrichten.',

    // UserChatPage
    'userChat.loading': 'Wird geladen…',
    'userChat.error': 'Fehler: {error}',
    'userChat.noMessages': 'Keine Nachrichten',
    'userChat.placeholder': 'Nachricht schreiben…',
    'userChat.toProfile': 'Zum Profil',

    // SearchMatchDialog
    'search.completeStep3': 'Bitte Schritt 3 abschließen, bevor Verfügbarkeiten gesetzt werden.',
    'search.pickDate': 'Bitte Datum wählen.',
    'search.invalidTimeRange': 'Bitte gültige Zeitspanne wählen (von < bis).',
    'search.invalidTimeRanges': 'Bitte gültige Zeitspannen wählen (von < bis).',
    'search.pickTimeSlot': 'Bitte mindestens einen Zeitraum auswählen.',
    'search.pickDateFirst': 'Bitte Datum wählen.',
    'search.loginFirst': 'Bitte zuerst anmelden.',
    'search.pickSportCity': 'Bitte Sportart und Stadt auswählen.',
    'search.pickLevel': 'Bitte wähle ein Level aus',
    'search.pickDateSlot': 'Bitte mindestens ein Datum wählen.',
    'search.enterAvailability': 'Bitte mindestens einen verfügbaren Zeitraum eintragen',
    'search.createFailed': 'Konnte Match nicht erstellen',
    'search.createError': 'Fehler beim Erstellen',
    'search.createMatch': 'Match erstellen',
    'search.loginToCreate': 'Einloggen um zu erstellen',
    'search.sportPlaceholder': 'Sportart wählen',
    'search.cityPlaceholder': 'Stadt',
    'search.next3d': 'In den nächsten 3 Tagen',
    'search.next7d': 'In den nächsten 7 Tagen',
    'search.next14d': 'In den nächsten 14 Tagen',
    'search.next30d': 'In den nächsten 30 Tagen',
    'search.pickTimeRange': 'Zeitraum wählen',
    'search.pickDays': 'Tage wählen',
    'search.noMatches': 'Keine offenen Matches gefunden.',
    'search.player': 'Spieler',
    'search.lookingForOpponent': 'Gegner gesucht',
    'search.statusPending': 'Ausstehend',
    'search.dateOpen': 'Datum: offen',
    'search.timeOpen': 'Zeitraum: offen',
    'search.statusOpen': 'Offen',
    'search.statusPlanned': '📅 Geplant',
    'search.statusOpenIcon': '🟢 Offen',
    'search.rangeNextDays': 'In den nächsten {count} Tagen',
    'search.rangeNext1Day': 'In den nächsten 1 Tag',
    'search.mapDescription': 'Die Kartenansicht zeigt alle verfügbaren Matches auf einer interaktiven Karte mit ihren Standorten.',
    'search.mapComingSoon': '🚧 In Entwicklung - Verfügbar in einer kommenden Version',
    'search.sportPlaceholderIcon': '🏃 Sportart wählen',
    'search.citySelect': 'Stadt wählen',
    'search.bookCourtOptional': '🏟️ Platz buchen (optional)',
    'search.desiredTime': 'Gewünschter Zeitpunkt',
    'search.dateLabel': 'Datum',
    'search.inNext': 'In den nächsten:',
    'search.fromDate': 'Von (Start-Datum)',
    'search.toDate': 'Bis (End-Datum)',
    'search.globalTimeNote': 'Gilt für alle Verfügbarkeiten dieses Matches.',
    'search.enterAvailabilities': 'Verfügbarkeiten eintragen',
    'search.timeSlotsAll': 'Zeiträume für alle Tage',
    'search.availPerDay': 'Verfügbarkeit pro Tag',
    'search.chooseTimeSlots': 'Wähle einen oder mehrere Zeiträume...',
    'search.pleasePickTime': 'Bitte oben einen Zeitraum wählen.',
    'search.availableCourts': 'Verfügbare Plätze',
    'search.searchingCourts': 'Suche verfügbare Plätze...',
    'search.noCourts': 'Keine freien Plätze für diese Auswahl verfügbar',
    'search.freeCourtSingular': 'freier Platz',
    'search.freeCourtPlural': 'freie Plätze',
    'search.bookAtLocation': 'Platz bei {name} buchen',
    'search.bookCourt': 'Platz buchen',
    'search.creating': 'Erstelle Match...',

    // UserDetailPage
    'user.opponentUnknown': 'Gegner unbekannt',
    'user.loginForFriends': 'Bitte melde dich an, um Freundschaften zu verwalten.',
    'user.friendEnded': 'Freundschaft beendet',
    'user.friendConfirmed': 'Freundschaft bestätigt',
    'user.friendRequested': 'Freundschaftsanfrage gesendet',
    'user.loginForRequests': 'Bitte melde dich an, um deine Match-Anfragen zu verwalten.',
    'user.saveFailed': 'Speichern fehlgeschlagen.',
    'user.invalidId': 'Ungültige Benutzer-ID.',
    'user.nextMatch': 'Nächstes Match',
    'user.winAgainst': 'Sieg gegen',
    'user.lossAgainst': 'Niederlage gegen',
    'user.drawAgainst': 'Remis gegen',
    'user.memberSince': 'Mitglied seit',
    'user.leagueMember': 'Liga-Mitglied',
    'user.loading': 'Lade Profil …',
    'user.motto.open': 'Trau dich – offen für Matches',
    'user.motto.welcome': 'Match-Anfragen willkommen',
    'user.motto.new': 'Neu in der Liga',
    'user.uploadAvatar': 'Neues Profilbild hochladen',
    'user.disableRequests': 'Match-Anfragen deaktivieren',
    'user.enableRequests': 'Match-Anfragen aktivieren',
    'user.editProfile': 'Profil bearbeiten',
    'user.endFriendship': 'Freundschaft beenden',
    'user.sendMessage': 'Nachricht senden',
    'user.lastForm': 'Letzte Form',
    'user.upcomingForm': 'Nächste Begegnungen & aktuelle Form',
    'user.upcomingMatches': 'Nächste Matches',
    'user.noUpcoming': 'Keine kommenden Matches',
    'user.viewProfile': 'Profil anzeigen',
    'user.opponent': 'Gegner',
    'user.last3': 'Letzte 3 Spiele',
    'user.myRankings': 'Deine Platzierungen in den Ligen',
    'user.rankingsOf': 'Platzierungen von {name}',
    'user.allLeagues': 'Alle Ligen',
    'user.loadingTable': 'Lade Tabelle …',
    'user.noTableData': 'Keine Tabellendaten verfügbar.',
    'user.noActivities': 'Keine Aktivitäten verfügbar.',
    'user.noMatchNews': 'Keine Match-News verfügbar.',
    'user.noFriendActivity': 'Keine Freundes-Aktivitäten verfügbar.',
    'user.noPublicActivity': 'Keine öffentlichen Aktivitäten verfügbar.',
    'user.uploadTitle': 'Profilbild hochladen',
    'user.uploadSuccess': '✅ Profilbild erfolgreich hochgeladen!',
    'user.avatarAlt': 'Profilbild',
  },
  en: {
    'lang.switch': 'DE',
    'lang.title': 'Switch language',
    'nav.login': 'Login',
    'nav.leagues': 'Leagues',
    'nav.subscriptions': 'Subscriptions',
    'nav.tasks': 'Tasks',
    'nav.register': 'Register',
    'nav.profile': 'Profile',
    'nav.teams': 'Teams',
    'nav.booking': 'Book court',
    'nav.training': 'Training',
    'nav.clubs': 'Clubs',
    'nav.chats': 'Chats',
    'nav.news': 'News',
    'nav.compliance': 'Compliance',
    'nav.logout': 'Logout',

    'nav.teamManager': 'Team Manager',
    'nav.competitionManager': 'Competition',
    'nav.clubManager': 'Club Manager',
    'nav.locationManager': 'Venue Manager',
    'nav.myMatches': 'My Matches',

    'myMatches.title': 'My Matches',
    'myMatches.loading': 'Loading matches…',
    'myMatches.loadError': 'Failed to load matches',
    'myMatches.upcoming': 'Upcoming',
    'myMatches.completed': 'Completed',
    'myMatches.noUpcoming': 'No upcoming matches.',
    'myMatches.noCompleted': 'No completed matches yet.',
    'myMatches.findMatch': 'Find match',
    'myMatches.statusPending': 'Result pending',
    'myMatches.statusDisputed': 'Result disputed',
    'myMatches.statusCompleted': 'Completed',
    'myMatches.statusCancelled': 'Cancelled',
    'myMatches.statusScheduled': 'Scheduled',

    'subs.title': 'Subscriptions',
    'subs.subtitle': 'MVP1: Only FREE USER is active. All other roles are coming soon.',
    'subs.rolesTitle': 'Available roles',
    'subs.plansTitle': 'Plans',
    'subs.footer': 'For more information or custom offers, contact us.',
    'subs.billing.free': 'Free',
    'subs.billing.comingSoon': 'Soon',
    'badge.active': 'Active',
    'badge.internal': 'Internal',
    'badge.comingSoon': 'Coming Soon',

    'start.loading': 'Loading start page ...',
    'start.errorPrefix': 'Error',
    'start.welcome': 'Welcome to MatchLeague. Connect. Match. Win.',
    'start.sportPlaceholder': 'Sport',
    'start.cityPlaceholder': 'City',
    'start.searchMode': 'Search mode',
    'start.mode.match': 'Match',
    'start.mode.competition': 'Competition',
    'start.mode.competitionSoon': 'Competition (Coming soon)',
    'start.mode.slot': 'Book slot',
    'start.mode.slotSoon': 'Book slot (Coming soon)',
    'start.search': 'Search',
    'start.searching': 'Searching…',
    'start.upcoming': 'Upcoming games',
    'start.noUpcoming': 'No upcoming games.',
    'start.findMatch': 'Find a match',
    'start.recent': 'Recent games',
    'start.noRecent': 'No recent games.',
    'start.details': 'Details',
    'start.toLeague': 'To league',
    'start.noStandings': 'No standings available.',

    'start.activities.title': 'Activity',
    'start.activities.subtitle': 'Latest updates',
    'start.activities.filter.all': '📋 All',
    'start.activities.filter.matches': '⚽ Match news',
    'start.activities.filter.friends': '👥 Friends',
    'start.activities.empty.all': 'No activity available.',
    'start.activities.empty.matches': 'No match news available.',
    'start.activities.empty.friends': 'No friend activity available.',
    'start.activities.adLabel': 'AD',
    'start.activities.showCourts': 'Show available courts',
    'start.loadError': 'Load error.',
    'start.myLeagues.title': 'My leagues',
    'start.myLeagues.none': 'You are not a member of any league yet.',
    'start.myLeagues.searchLeague': 'Find leagues',
    'start.myLeagues.leagueLabel': 'League:',

    'profile.title': 'Profile',
    'profile.errorOpen': 'Could not open profile. Please go to the start page and open your profile again.',
    'profile.toStart': 'To start page',

    'login.stats.loading': 'Loading stats…',
    'login.stats.users': 'Users',
    'login.stats.confirmed': 'Confirmed',
    'login.stats.leagues': 'Leagues',
    'login.stats.matches': 'Matches',
    'login.stats.teams': 'Teams',
    'login.stats.teamMembers': 'Team members',
    'login.stats.memberships': 'League memberships',
    'login.stats.sports': 'Sports',

    'login.unconfirmed.title': 'Email not confirmed',
    'login.unconfirmed.subtitle': 'Please confirm {email}',
    'login.unconfirmed.sending': 'Sending...',
    'login.unconfirmed.resend': 'Resend email',

    'login.reset.title': 'Forgot password?',
    'login.reset.msg1': 'Would you like to receive a password reset link via email to',
    'login.reset.msg2': '?',
    'login.reset.yourEmail': 'your email address',
    'login.reset.cancel': 'Cancel',
    'login.reset.sending': 'Sending...',
    'login.reset.send': 'Yes, send email',
    'login.reset.enterEmailFirst': 'Please enter your email address in the login form first.',
    'login.reset.sentTitle': 'Email sent!',
    'login.reset.sentMsg1': 'We sent you a password reset link to',
    'login.reset.sentMsg2': '. Please check your inbox.',
    'login.reset.close': 'Close',

    'login.resend.ok': '✅ Confirmation email resent!',
    'login.resend.wait': '⏱️ Please wait {minutes} more minutes before requesting another email.',
    'login.resend.error': 'Failed to send email.',
    'login.serverUnreachable': 'Server not reachable.',
    'login.password.placeholder': 'Password',
    'login.password.hide': 'Hide password',
    'login.password.show': 'Show password',
    'login.password.changedOk': '✅ Password changed successfully!',
    'login.password.resetError': 'Reset failed.',
    'login.register': 'Register',
    'login.tagline': 'A quick overview of platform activity — growing every day.',
    'login.communityStatsTitle': 'Community stats',
    'login.updatedAt': 'Updated: {time}',

    'start.geo.notSupported': 'Your browser does not support geolocation.',
    'start.geo.fetchCityError': 'Could not fetch nearest city. Please select your city manually.',
    'start.geo.noCityFound': 'No nearby city found. Please select your city manually.',
    'start.geo.denied': 'Location permission was denied. Please allow access in your browser settings.',
    'start.geo.unavailable': 'Location could not be determined.',
    'start.geo.timeout': 'Location request timed out.',
    'start.geo.generic': 'Location detection failed. Please select your city manually.',

    'footer.impressum': 'Imprint',
    'footer.privacy': 'Privacy',
    'footer.terms': 'Terms',
    'footer.report': 'Report illegal content',

    'report.title': 'Report illegal content',
    'report.subtitle': 'Reporting procedure under the Digital Services Act (DSA)',
    'report.intro': 'MatchLeague provides a reporting process under the DSA.',
    'report.reportable': 'You can report in particular:',
    'report.item1': 'illegal content',
    'report.item2': 'insulting or discriminatory content',
    'report.item3': 'inappropriate profile images',
    'report.item4': 'platform abuse',
    'report.info': 'Reports are captured and processed directly in the compliance system.',
    'report.requiredUserId': 'Required: Please provide the visible user ID from the reported profile.',
    'report.name': 'Your name (optional)',
    'report.email': 'Your email (optional)',
    'report.reportedUserId': 'Reported user ID (from profile)',
    'report.subject': 'Subject',
    'report.url': 'Link to reported content (optional)',
    'report.message': 'Describe the incident as precisely as possible',
    'report.send': 'Send report',
    'report.sending': 'Sending report …',
    'report.success': 'Thanks, your report was recorded (ID #{id}).',
    'report.errSend': 'Report could not be sent.',
    'report.cat.illegal': 'Illegal content',
    'report.cat.insultDefamation': 'Insult / defamation',
    'report.cat.hate': 'Hate speech / discrimination',
    'report.cat.harassment': 'Harassment / discrimination',
    'report.cat.profile': 'Inappropriate profile image',
    'report.cat.abuse': 'Platform abuse',
    'report.cat.other': 'Other',

    'compliance.title': 'Compliance Dashboard',
    'compliance.subtitle': 'Open reports and task board',
    'compliance.noAccess': 'No access. This page is available for admins only.',
    'compliance.refresh': 'Refresh',
    'compliance.open': 'Open',
    'compliance.inReview': 'In review',
    'compliance.resolved': 'Resolved',
    'compliance.rejected': 'Rejected',
    'compliance.total': 'Total',
    'compliance.openReports': 'Open reports',
    'compliance.loadingReports': 'Loading reports …',
    'compliance.noReports': 'No open reports.',
    'compliance.category': 'Category',
    'compliance.reporter': 'Reporter',
    'compliance.unknown': 'unknown',
    'compliance.reportedUserId': 'Reported user ID',
    'compliance.url': 'URL',
    'compliance.setInReview': 'Set in review',
    'compliance.markResolved': 'Mark resolved',
    'compliance.createTask': 'Create task',
    'compliance.taskLinked': 'Task #{id} linked',
    'compliance.taskboardOpen': 'Task board (open)',
    'compliance.noOpenTasks': 'No open tasks.',
    'compliance.assignee': 'Assignee',
    'compliance.errorLoad': 'Could not load compliance data.',
    'compliance.errorUpdate': 'Could not update report.',
    'compliance.errorTaskCreate': 'Could not create task.',
    'compliance.errorTaskLink': 'Could not link report with task.',

    'match.cta.title': 'Looking for players!',
    'match.cta.teamText': '{name} is looking for players for this match. ({joined}{cap})',
    'match.cta.opponentText': '{name} is looking for an opponent for this match. Join and challenge them!',
    'match.cta.joinNow': '✨ Join now',
    'match.cta.acceptChallenge': '⚔️ Accept challenge',
    'match.cta.weeklyLimit': 'You already have a match in this league this week.',
    'match.join.loginRequired': 'Please log in.',
    'match.join.ok': 'Joined.',
    'match.join.failed': 'Join failed.',
    'match.team.selectTitle': 'Select team',
    'match.team.team1': 'Team 1',
    'match.team.team2': 'Team 2',
    'match.team.selected': 'Team selected.',
    'match.team.selectFailed': 'Team selection failed.',
    'match.team.teamFull': 'This team is already full.',
    'match.team.notSelected': 'You haven\'t selected a team yet. Pick your team to get started!',
    'match.loading': 'Loading match ...',
    'match.errorPrefix': 'Error',
    'match.save.loading': '⏳ Saving...',
    'match.saveResult': 'Save result',
    'match.save.error': 'Failed to save.',
    'match.slots.loadError': 'Failed to load slots',
    'match.schedule.pickDateTime': 'Please choose date and time.',
    'match.schedule.proposalTaken': 'Proposal applied. Please save.',
    'match.schedule.saving': '⏳ Saving time...',
    'match.schedule.saved': '✅ Time saved!',
    'match.schedule.failed': 'Failed to set time.',
    'match.schedule.editDate': 'Edit schedule',
    'match.schedule.setLocation': '1️⃣ Set location',
    'match.schedule.bookCourt': '🏟️ Book court',
    'match.schedule.bookNow': 'Book now →',
    'match.schedule.manualLocation': '📍 Enter location manually',
    'match.schedule.timeDisplay': '🕐 {start} - {end}',
    'match.suggest.failed': 'Suggestion failed.',
    'match.cancel.failed': 'Cancel failed.',
    'match.cancel.confirm': 'Do you really want to cancel this match?',
    'match.cancel.success': 'Match has been cancelled.',
    'match.proposal.accepted': '✅ Time accepted! Match start date has been set.',
    'match.proposal.rejected': 'Proposal rejected',
    'match.result.saved': '✅ Result saved!',
    'match.result.pendingTitle': 'Result pending confirmation',
    'match.result.opponentSubmitted': 'Your opponent submitted this result. Do you agree?',
    'match.result.waitingForOpponent': 'Waiting for your opponent to confirm the result...',
    'match.result.confirm': 'Confirm',
    'match.result.reject': 'Reject',
    'match.timeoutRetry': '⚠️ Timeout — please try again.',
    'match.notFound': 'Match not found.',
    'match.cannot.kickoffNotSet': '📅 Time not set yet',
    'match.cannot.kickoffNotReached': '⏰ Result can only be entered after the start time',
    'match.cannot.leagueMembersOnly': '🔒 League members only',
    'match.proposal.acceptError': 'Failed to accept',
    'match.proposal.rejectError': 'Failed to reject',
    'match.timeLocation.save': '💾 Save time & location',

    // Rank
    'match.rank': '{rank}. Rank',

    // Proposal labels
    'match.proposal.title': '📅 Schedule Proposal',
    'match.proposal.byYou': 'by you',
    'match.proposal.byOpponent': 'by opponent',
    'match.proposal.pending': 'pending',
    'match.proposal.accept': 'Accept',
    'match.proposal.counter': 'Counter-proposal',
    'match.proposal.reject': 'Decline',
    'match.proposal.details': 'View details',
    'match.proposal.label': 'Schedule proposal',

    // League fallback
    'match.leagueFallback': 'League',
    'match.notLoggedIn': 'Not logged in',
    'match.termin.change': 'Change time',
    'match.termin.arrange': 'Schedule match',
    'match.termin.invitationSent': 'Invitation sent',
    'match.termin.proposalReceived': 'Time proposal received',
    'match.teamAvailability.title': 'Add your availability',
    'match.teamAvailability.hint': 'After joining, enter your available times in the schedule manager right away. The match creator can then set the final date based on the overlapping slots.',
    'match.teamAvailability.open': 'Open schedule manager',
    'match.teamAvailability.prompt': 'Team joined. Please enter your availability in the schedule manager now.',

    'match.networkError': 'Network error',
    'match.chat': 'Match Chat',
    'match.deadline.hint': '{remaining} to schedule the match',
    'match.scheduled.countdown': '{remaining} until the match',
    'match.cancel': 'CANCEL',
    'match.lastForm': 'Last 5',
    'match.form.win': 'W',
    'match.form.draw': 'D',
    'match.form.loss': 'L',

    // Time relative
    'match.time.inDays': 'in {count} days',
    'match.time.agoDays': '{count} days ago',
    'match.time.inHours': 'in {count} hours',
    'match.time.agoHours': '{count} hours ago',
    'match.time.inMinutes': 'in {count} minutes',
    'match.time.agoMinutes': '{count} minutes ago',
    'match.time.expired': 'expired',
    'match.time.remainDays': '{count} days left',
    'match.time.remain1Day': '1 day left',
    'match.time.remainHours': '{count} hours left',
    'match.time.remainMinutes': '{count} minutes left',

    // Status labels
    'match.status.completed': 'Completed',
    'match.status.scheduled': 'Match scheduled',
    'match.status.pending': 'Match pending',
    'match.status.datePending': 'Date pending',
    'match.status.completedNoResult': 'Completed / no result',
    'match.status.live': 'Live',
    'match.status.ongoing': 'Ongoing',
    'match.status.today': 'Today',
    'match.status.cancelled': 'Cancelled',
    'match.status.resultPending': 'Result pending',
    'match.status.resultDisputed': 'Result disputed',

    // Date display
    'match.date.rangeNext': '📅 Within the next {count} days',
    'match.date.rangeNext1': '📅 Within the next day',
    'match.date.period': '📅 Period: {from} - {to}',
    'match.date.until': '📅 Until {date}',
    'match.date.noneYet': '⏰ No schedule set yet',
    'match.date.periodLabel': 'Period: {from} - {to}',
    'match.date.periodFlex': 'Period flexible',
    'match.date.fixedDate': '📅 Fixed date',
    'match.date.dateOpen': '🕐 Date open',
    'match.date.untilPlain': 'Until {date}',

    'match.result.entryTitle': 'Enter result',
    'match.tennis.setCount': 'Number of sets:',
    'match.result.requiresTime': '📅 Result can only be entered once a time is set.',
    'match.booking.locationLabel': 'Place / address',
    'match.booking.locationPlaceholder': 'Select location',
    'match.booking.date': '📅 Date',
    'match.booking.time': '🕐 Time',
    'match.booking.city': '📍 City',
    'match.booking.cityDefault': 'Default: {city}',
    'match.booking.allCities': 'All cities',
    'match.booking.availableCourts': 'Available courts',
    'match.booking.courtsCount': '{count} courts',
    'match.booking.searchingCourts': 'Searching available courts...',
    'match.booking.noCourtsFound': 'No available courts found',
    'match.booking.forTime': 'for {date} at {time}',
    'match.booking.tryOther': 'Try a different date or time.',
    'match.booking.nextFree': 'NEXT FREE COURT',

    // SearchMatchDialog
    'match.search.presetMorning': '🌅 Morning',
    'match.search.presetMidday': '☀️ Midday',
    'match.search.presetEvening': '🌙 Evening',
    'match.search.errorCompleteStep3': 'Please complete step 3 before setting availabilities.',
    'match.search.errorSelectDate': 'Please select a date.',
    'match.search.errorValidTimeRange': 'Please select a valid time range (from < to).',
    'match.search.errorSlotConflict': 'Conflict: Overlap with existing slot.',
    'match.search.errorValidTimeRanges': 'Please select valid time ranges (from < to).',
    'match.search.errorOverlappingSlots': 'Conflict: Overlapping slots on the same day.',
    'match.search.errorSelectTimePeriod': 'Please select at least one time period.',
    'match.search.errorNoTimePeriodAdded': 'No time period added (possible conflicts).',
    'match.search.errorLoginFirst': 'Please log in first.',
    'match.search.errorSelectSportCity': 'Please select a sport and city.',
    'match.search.errorSelectLevel': 'Please select a level',
    'match.search.errorSelectAtLeastOneDate': 'Please select at least one date.',
    'match.search.errorEnterAvailability': 'Please enter at least one available time period',
    'match.search.errorCreateFailed': 'Could not create match',
    'match.search.errorCreatingMatch': 'Error creating match',
    'match.search.title': 'Search Match',
    'match.search.createMatch': 'Create Match',
    'match.search.loginToCreate': 'Log in to create',
    'match.search.openOwnMatch': 'Create your own match',
    'match.search.selectSport': 'Select sport',
    'match.search.city': 'City',
    'match.search.next3Days': 'In the next 3 days',
    'match.search.next7Days': 'In the next 7 days',
    'match.search.next14Days': 'In the next 14 days',
    'match.search.next30Days': 'In the next 30 days',
    'match.search.selectPeriod': 'Select period',
    'match.search.selectDays': 'Select days',
    'match.search.tableView': 'Table view',
    'match.search.cardView': 'Card view',
    'match.search.mapView': 'Map view',
    'match.search.thSport': 'Sport',
    'match.search.thPlayer': 'Player',
    'match.search.thLocation': 'Location',
    'match.search.thTime': 'Time',
    'match.search.thAction': 'Action',
    'match.search.opponentWanted': 'Opponent wanted',
    'match.search.statusPending': 'Pending',
    'match.search.dateOpen': 'Date: open',
    'match.search.inDays': 'In {days} day(s)',
    'match.search.periodOpen': 'Period: open',
    'match.search.levelOpen': 'Open',
    'match.search.statusOpen': '🟢 Open',
    'match.search.statusScheduled': '📅 Scheduled',
    'match.search.inNextDays': 'In the next {days} day(s)',
    'match.search.dateFixedRange': 'on {dayName} {date}, between {start}-{end}',
    'match.search.dateExact': 'on {dayName} {date}, at {time}',
    'match.search.noResults': 'No open matches found.',
    'match.search.mapViewTitle': 'Map View',
    'match.search.mapViewDesc': 'The map view shows all available matches on an interactive map with their locations.',
    'match.search.mapViewWip': '🚧 In development - Available in an upcoming version',
    'match.search.step1Label': 'Sport and Location',
    'match.search.selectSportEmoji': '🏃 Select sport',
    'match.search.selectCity': 'Select city',
    'match.search.bookVenueOptional': '🏟️ Book venue (optional)',
    'match.search.noVenueSelected': 'No venue selected',
    'match.search.desiredTime': 'Desired Time',
    'match.search.fixedDay': 'Fixed Day',
    'match.search.period': 'Period',
    'match.search.timeWindow': 'Time Window',
    'match.search.date': 'Date',
    'match.search.inTheNext': 'In the next:',
    'match.search.threeDays': '3 Days',
    'match.search.sevenDays': '7 Days',
    'match.search.fourteenDays': '14 Days',
    'match.search.fromStartDate': 'From (Start Date)',
    'match.search.toEndDate': 'To (End Date)',
    'match.search.preferredTimeOptional': 'Preferred time (optional)',
    'match.search.specificTime': 'Specific Time',
    'match.search.timeOfDay': 'Time of Day',
    'match.search.from': 'From',
    'match.search.to': 'To',
    'match.search.gameDuration': 'Game Duration',
    'match.search.gameDurationDesc': 'Game duration (applies to the entire match)',
    'match.search.decreaseDuration': 'Decrease duration',
    'match.search.increaseDuration': 'Increase duration',
    'match.search.appliesAllAvailabilities': 'Applies to all availabilities of this match.',
    'match.search.enterAvailabilities': 'Enter Availabilities',
    'match.search.configuration': 'Configuration',
    'match.search.periodsForAllDays': 'Time periods for all days',
    'match.search.availabilityPerDay': 'Availability per day',
    'match.search.presetHint': 'Select one or more time periods. They will be applied to all selected days when submitting.',
    'match.search.pleaseSelectPeriodAbove': 'Please select a time period above.',
    'match.search.removeRow': 'Remove row',
    'match.search.addNewRow': '+ New row',
    'match.search.availableVenues': 'Available Venues',
    'match.search.searchingVenues': 'Searching available venues...',
    'match.search.noVenuesAvailable': 'No available venues for this selection',
    'match.search.priceOnRequest': 'Price on request',
    'match.search.freeSlot': 'free slot',
    'match.search.freeSlots': 'free slots',
    'match.search.bookVenueAt': 'Book venue at {name}',
    'match.search.bookVenue': 'Book venue',
    'match.search.cancel': 'Cancel',
    'match.search.creatingMatch': 'Creating match...',

    'tm.title': 'Schedule Manager',
    'tm.loading': 'Loading...',
    'tm.availableTimes': 'Available Times',
    'tm.addSlot': 'Add slot',
    'tm.closeSlot': 'Close',
    'tm.noTimes': 'No times added yet.',
    'tm.date': 'Date',
    'tm.from': 'From',
    'tm.to': 'To',
    'tm.save': 'Save',
    'tm.cancel': 'Cancel',
    'tm.fillDateAndTime': 'Please fill in date and time',
    'tm.endAfterStart': 'End time must be after start time',
    'tm.saveError': 'Error saving',
    'tm.latestStart': 'Latest start: {time}',
    'tm.duration': 'Duration {min} min',
    'tm.sendInvitation': 'Send invitation',
    'tm.onlyGuestCanSend': 'Only the guest can send a request.',
    'tm.invalidTime': 'Invalid time.',
    'tm.outsideFrame': 'Start time is outside the host slot.',
    'tm.sendError': 'Error sending',
    'tm.yourAvailability': 'Your Availability',
    'tm.yourSlot': 'Your slot',
    'tm.opponentAvailability': 'Opponent Availability',
    'tm.proposals': 'Schedule Proposals',
    'tm.noRequests': 'No requests yet.',
    'tm.proposal': 'Schedule proposal',
    'tm.byYou': 'by you',
    'tm.byOpponent': 'by opponent',
    'tm.byHost': 'by host',
    'tm.status': 'Status',
    'tm.pending': 'pending',
    'tm.accept': 'Accept',
    'tm.counterProposal': 'Counter-proposal',
    'tm.reject': 'Decline',
    'tm.withdraw': 'Withdraw',
    'tm.acceptSlot': 'Accept',
    'tm.sendCounter': 'Send counter-proposal',
    'tm.proposeTime': 'Propose time',
    'tm.availableRange': 'Available: {from} - {to}',
    'tm.playTime': 'Play time: {min} min',
    'tm.desiredStart': 'Desired start time',
    'tm.ofAvailable': '{current} of {total} available times',
    'tm.sending': 'Sending...',
    'tm.sendInvitationFull': 'Send invitation',
    'tm.counterSent': 'Counter-proposal sent successfully!',
    'tm.invitationSent': 'Invitation sent successfully!',
    'tm.proposalRejected': 'Proposal rejected',
    'tm.selectStartTime': 'Please select a start time',
    'tm.outsideAvail': 'Start time is outside the availability slot.',
    'tm.acceptError': 'Error accepting',
    'tm.deleteError': 'Error deleting',
    'tm.rejectError': 'Error rejecting',
    'tm.player1': 'Player 1',
    'tm.player2': 'Player 2',
    'tm.slotCount': '{count} slot(s)',
    'tm.myTimes': 'My Availability',
    'tm.myTimesHint': 'Your time slots for this match.',
    'tm.noMyTimes': 'No times added yet. Add time slots when you are available to play.',
    'tm.opponentTimes': 'Opponent Availability',
    'tm.opponentTimesHint': 'Your opponent\'s available times. Choose one and send a match request.',
    'tm.delete': 'Delete',
    'tm.deleteFrameConfirm': 'Delete this time slot?',
    'tm.frameSaved': 'Time slot saved!',
    'tm.frameDeleted': 'Time slot deleted.',
    'tm.slotProposed': 'Match request sent!',
    'tm.slotAccepted': 'Match confirmed!',

    'common.cancel': 'Cancel',
    'common.openProfile': 'Open profile',

    'register.minAge': 'You must be at least 16 years old to register.',
    'register.confirmAgeTerms': 'Please confirm you are at least 16 years old and accept the terms and privacy policy.',
    'register.success': 'Registration successful! Please check your email and confirm the link.',
    'register.failed': 'Registration failed. Please check your details.',
    'register.button': 'Register',
    'register.sending': 'Sending...',
    'register.title': 'Register',
    'register.subtitle': 'Create your account and become part of the community',
    'register.firstName': 'First name',
    'register.lastName': 'Last name',
    'register.email': 'Email',
    'register.password': 'Password',
    'register.passwordConfirm': 'Confirm password',
    'register.passwordRepeat': 'Repeat password',
    'register.passwordMismatch': 'Passwords do not match',
    'register.passwordMatch': '✓ Passwords match',
    'register.cityDistrictPlaceholder': 'Choose city or district',
    'register.locationOptional': 'Location (optional)',
    'register.birthday': 'Birthday',
    'register.gender': 'Gender',
    'register.genderPlaceholder': '-- Choose gender --',
    'register.gender.male': 'Male',
    'register.gender.female': 'Female',
    'register.gender.other': 'Other',
    'register.terms': 'I confirm that I am at least 16 years old and accept the',
    'register.terms.termsLink': 'Terms of use',
    'register.terms.privacyLink': 'Privacy policy (GDPR)',
    'register.alreadyRegistered': 'Already registered?',
    'register.toLogin': 'Go to login',

    'subs.features.teamCaptain': 'Create team / members / league registration',
    'subs.features.clubOwner': 'Manage multiple teams / assign coaches / club dashboard',
    'subs.features.locationOwner': 'Create venue / define courts / generate slots',
    'subs.features.eventOwner': 'Create league / standings / configure tournaments',
    'subs.features.trainer': 'Plan training / manage participants / track performance',

    'editProfile.loadError': 'Failed to load profile',
    'editProfile.saveOk': 'Profile saved successfully',
    'editProfile.saveErrorPrefix': 'Save failed: {error}',
    'editProfile.loading': 'Loading...',
    'editProfile.saveChanges': 'Save changes',
    'editProfile.saving': 'Saving...',
    'editProfile.selectPlaceholder': 'Please choose',
    'editProfile.title': 'Edit personal data',
    'editProfile.gender': 'Gender',
    'editProfile.back': 'Back',
    'editProfile.gender.male': 'Male',
    'editProfile.gender.female': 'Female',
    'editProfile.gender.diverse': 'Other',
    'editProfile.gender.na': 'Prefer not to say',
    'editProfile.bio': 'Bio / About me',
    'editProfile.bioPlaceholder': 'Tell us about yourself...',
    'editProfile.locationPlaceholder': 'Select location',

    'match.creator.title': 'Looking for players',
    'match.creator.subtitle': 'Your match is published and visible to all players.',
    'match.creator.badgeActive': '🎯 Match active',

    'league.join.ok': '✅ Joined.',
    'league.join.alreadyMember': 'Already a member',
    'league.join.paired': 'A match was assigned to you right away.',
    'league.join.created': 'An open match was created for you.',
    'league.join.existing': 'You already had an open match.',
    'league.join.error': 'Match assignment failed: {error}.',
    'league.join.auto.joined': 'Auto match search: you were added to an open match.',
    'league.join.auto.created': 'Auto match search: open match created.',
    'league.join.auto.paired': 'Auto match search: opponent found.',
    'league.join.auto.skipped': 'Auto match search: an open match already exists.',

    'league.loading': 'Loading league ...',
    'league.noData': 'No data.',
    'league.pickOpponent': 'Please choose an opponent.',
    'league.pickDateTime': 'Please choose date/time.',
    'league.createMatchFailed': 'Create match failed: {error}',
    'league.searchMatch': 'Find match',
    'league.searching': 'Searching...',
    'league.search.result.joined': 'Match found and joined',
    'league.search.result.created': 'Open match created',
    'league.search.result.paired': 'Found an opponent without a weekly match. Proposal created.',
    'league.search.result.skipped': 'You already have an open match.',
    'league.search.failed': 'Match search failed: {error}',
    'league.openMatch.notice': 'You already have an open match.',
    'league.openMatch.toMatch': 'To match',
    'league.weeklyLimit': 'You already had a match this week. Match search will be available again next week.',
    'league.loadingExtra': 'Loading additional data...',
    'league.table.title': 'Standings',
    'league.table.season': 'Season:',
    'league.table.currentSeason': 'Current season',
    'league.table.noEntries': 'No entries.',
    'league.table.place': 'Place',
    'league.table.teamPlayer': 'Team/player',
    'league.table.played': 'P',
    'league.table.won': 'W',
    'league.table.draw': 'D',
    'league.table.lost': 'L',
    'league.table.goals': 'Goals',
    'league.table.diff': 'Diff',
    'league.table.points': 'Pts',
    'league.table.form': 'Form',
    'league.backToOverview': '← Back to overview',
    'league.openProfile': 'Open profile',
    'league.noUpcoming': 'No upcoming matches.',
    'league.noCompleted': 'No completed matches.',
    'league.noDataYet': 'No data yet',
    'league.leader': 'Table leader',
    'league.points': 'points',
    'league.games': 'games',
    'league.goals': 'goals',

    'leagues.info': 'ℹ️ Info',
    'leagues.join': 'Join',
    'leagues.loadingMore': 'Loading...',
    'leagues.loadMore': 'Load more ({current} of {total})',
    'leagues.loading': 'Loading leagues …',
    'leagues.title': 'Leagues',
    'leagues.subtitle': 'Find the perfect league for your sport in your region',
    'leagues.filterTitle': 'Filter & search',
    'leagues.searchLabel': 'Search',
    'leagues.searchPlaceholder': 'Search league, city, or sport...',
    'leagues.sportPlaceholder': 'Choose sport...',
    'leagues.cityPlaceholder': 'Choose city...',
    'leagues.resetFilters': 'Reset all filters',
    'leagues.foundCount': '{count} leagues found',
    'leagues.noneTitle': 'No leagues found',
    'leagues.noneHint': 'Try different filters or broaden your search',
    'leagues.moreAvailable': '{count} more leagues available',
    'leagues.detailUnavailable': 'Detail unavailable',
    'leagues.showing': 'Showing {shown} of {total} leagues',

    'match.createPublic.title': 'Create public match',
    'match.createPublic.subtitle': 'Create a public match that other players can find and join.',
    'match.createPublic.subtitleLong': 'Create a public match that other players can find and join. Choose sport, city, and an available venue.',
  },
};

const LanguageContext = createContext({
  lang: 'de',
  setLang: () => {},
  toggleLang: () => {},
  t: (key) => key,
});

function resolveInitialLanguage() {
  if (typeof window === 'undefined') return 'de';
  const saved = window.localStorage.getItem(STORAGE_KEY);
  if (saved === 'de' || saved === 'en') return saved;
  const browser = String(window.navigator?.language || '').toLowerCase();
  return browser.startsWith('en') ? 'en' : 'de';
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(resolveInitialLanguage);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(STORAGE_KEY, lang);
      document.documentElement.setAttribute('lang', lang);
    }
  }, [lang]);

  const value = useMemo(() => {
    const t = (key, vars = {}) => {
      const raw = translations[lang]?.[key] ?? translations.de[key] ?? key;
      return Object.keys(vars).reduce((acc, varKey) => acc.replace(`{${varKey}}`, String(vars[varKey])), raw);
    };

    return {
      lang,
      setLang,
      toggleLang: () => setLang((prev) => (prev === 'de' ? 'en' : 'de')),
      t,
    };
  }, [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  return useContext(LanguageContext);
}
